import { DatePipe } from "@angular/common";

export function searchIncludesSimple(search: string, terms: string): boolean {
	const termsSplit = terms.split(/[,; ]+/);
	return termsSplit.every(t => search.includes(t));
}

// *** all changes here must be coordinated with the back end's 'SearchHelpers' ***

export function searchIncludes(search: string, terms: string, datePipe: DatePipe): boolean {
	// TODO eventually it would be nice to move the terms split 
	// out of searchIncludes (which is inside filterPredicate)
	const termsSplit = splitSearchTerms(terms, datePipe);
	return termsSplit.every(t => search.includes(t));
}

function splitSearchTerms(terms: string, datePipe: DatePipe): string[] {
	let termsSplit: string[] = [];
	const leftOverTerms = extractQuotedSearchTerms(termsSplit, terms).trim();
	if (leftOverTerms) termsSplit.push(...leftOverTerms.split(/[,; ]+/));
	const termsSplitWithDates: string[] = termsSplit.map(t => {
		return parseTermAsFormattedDateString(t, datePipe);
	});

	return termsSplitWithDates;
}

function parseTermAsFormattedDateString(term: string, datePipe: DatePipe): string {
	// YYYY-MM-DD (e.g., 2025-02-18)
	// MM/DD/YYYY (e.g., 02/18/2025)
	// MM/DD/YY (e.g., 02/18/25)
	// MMM DD, YYYY (e.g., Feb 18, 2025)
	if (term.match(/^(?:(\d{4})-(\d{2})-(\d{2})|(\d{2})\/(\d{2})\/(\d{2})|(\d{2})\/(\d{2})\/(\d{4})|([A-Za-z]{3}) (\d{1,2}), (\d{4}))$/)) {
		const parseDate = Date.parse(term);
		if (parseDate) {
			return datePipe.transform(new Date(parseDate), 'yyyy-MM-dd', 'UTC');
		} 
	}
	return term;
}

function extractQuotedSearchTerms(termsSplit: string[], terms: string): string {
	const firstQuote = terms.indexOf('"');
	if (firstQuote === -1) return terms;
	const secondQuote = terms.indexOf('"', firstQuote + 1);
	if (secondQuote === -1) return terms;

	const quotedTerm = terms.substring(firstQuote + 1, secondQuote);
	termsSplit.push(quotedTerm);

	const remainingTerms = terms.replace(`"${quotedTerm}"`, "");
	const hasAnotherQuote = remainingTerms.indexOf('"');

	if (hasAnotherQuote >= 0) return extractQuotedSearchTerms(termsSplit, remainingTerms);
	else return remainingTerms;
}